
const state = {
  avatarBackground: {}
}

const mutations = {
  SET_AVATAR_BACKGROUND: (state, value) => {
    state.avatarBackground = { ...value }
  }
}

const actions = {
  setBackground({
    commit,
    state
  }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_AVATAR_BACKGROUND', data)
      resolve('')
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
